import { Component, OnInit } from '@angular/core';
import { ResellerService } from '../reseller-view/reseller.service';
import * as moment from "moment";

import { MatTableDataSource } from "@angular/material/table";
@Component({
  selector: 'app-resellermessagecount',
  templateUrl: './resellermessagecount.component.html',
  styleUrls: ['./resellermessagecount.component.scss']
})
export class ResellermessagecountComponent implements OnInit {
  formattedMonth1:any;
  formattedMonth2:any;
  formattedMonth3:any;
  formattedMonth4:any;
  formattedMonth5:any;
  formattedMonth6:any;
  formattedMonth7:any;
  formattedMonth8:any;
  formattedMonth9:any;
  formattedMonth10:any;
  formattedMonth11:any;
  formattedMonth12:any;
  formattedMonth13:any;
  pageLoader:boolean = true;
  page:number=1;
  paginationCount:number=0;
  monthName: any=[];
  monthName1: any=[];
  monthName2: any=[];
  monthName3: any=[];
  monthName4: any=[];
  monthName5: any=[];
  monthName6: any=[];
  monthName7: any=[];
  monthName8: any=[];
  monthName9: any=[];
  monthName10: any=[];
  monthName11: any=[];
  monthName12: any=[];
  year:any;
  year1:any;
  year2:any;
  year3:any;
  year4:any;
  year5:any;
  year6:any;
  year7:any;
  year8:any;
  year9:any;
  year10:any;
  year11:any;
  year12:any;
  dataSource: any=[];
  developerId:any;
  todaysDate: any = moment();
  sentPreviousMonth2Count:any;
  receivePreviousMonth2Count:any;
  receivePreviousMonth1Count:any;
  sentPreviousMonth1Count:any;
  sentPreviousMonth3Count:any;
  receivePreviousMonth3Count:any;
  sentPreviousMonth4Count:any;
  receivePreviousMonth4Count:any;
  sentPreviousMonth5Count:any;
  receivePreviousMonth5Count:any;
  sentPreviousMonth6Count:any;
  receivePreviousMonth6Count:any;
  sentPreviousMonth7Count:any;
  receivePreviousMonth7Count:any;
  sentPreviousMonth8Count:any;
  receivePreviousMonth8Count:any;
  sentPreviousMonth9Count:any;
  receivePreviousMonth9Count:any;
  sentPreviousMonth10Count:any;
  receivePreviousMonth10Count:any;
  sentPreviousMonth11Count: any;
  receivePreviousMonth11Count: any;
  sentPreviousMonth12Count: any;
  receivePreviousMonth12Count: any;
  sentTodayCount:any;
  receiveTodayCount:any;
  paginationDisabled: boolean=false;
  arr: any=[];
  applicationList: any=[];
  displayedColumns: string[] = ['resellerName', 'todayscount', 'previousmonth1count', 'previousmonth2count', 'previousmonth3count', 'previousmonth4count', 'previousmonth5count', 'previousmonth6count', 'previousmonth7count', 'previousmonth8count', 'previousmonth9count', 'previousmonth10count', 'previousmonth11count', 'previousmonth12count'];
  constructor( private resellerService: ResellerService,) { }

  ngOnInit(): void {
    let userId = JSON.parse(localStorage.getItem('user')).id;
    this.developerId = userId;
    
    let args = { "developerId": userId }
    this.resellerService.getResellerList(args).subscribe((data) => {
    
      if(data.info && data.info.length > 0) {
        this.dataSource = data.info;
        this.sentCount(data.info);
        this.paginationCount = data.info.length;
        this.arr = data.info;
      }
  },(err)=>{
    
    console.log("Error op", err);
  });
  this.pageLoader =true; 
  } 
  sentCount(applicationList:[]){
    const requestData = applicationList.slice((this.page - 1) * 5, (this.page - 1) * 5 + 5);
    requestData.forEach((element: any) => {  
      
    this.todaysDate = moment(this.todaysDate).format("YYYY-MM-DD");
    var datestart0 = moment(this.todaysDate).subtract(0,'months').startOf('month').format('YYYY-MM-DD');
    var dateend0 = moment(this.todaysDate).subtract(0,'months').endOf('month').format('YYYY-MM-DD');
    var check1 = moment(this.todaysDate, 'YYYY/MM/DD');
    var month1 = check1.format('M');
    this.formattedMonth1 = moment(month1, 'MM').format('MMMM');
    this.year1  = check1.format('YYYY');
      
      let argsw = { 
        developerId:  element.developerId,
        fromDate: datestart0,
        toDate: dateend0, 
      }
    
      this.resellerService.getTotalCount(argsw).subscribe( async (data) =>{
       if(data.status==200){
       element['sentTodayCount']=data.info.totalCount ?  data.info.totalCount  : 0;
       }
       });
       this.resellerService.getTotalReceivedCount(argsw).subscribe(async (data) =>{
        if(data.status==200){
          element['receiveTodayCount'] = data.info.totalCount ?  data.info.totalCount  : 0;
         
        }
        });

       var datestart1 = moment(this.todaysDate).subtract(1,'months').startOf('month').format('YYYY-MM-DD');
       var dateend1 = moment(this.todaysDate).subtract(1,'months').endOf('month').format('YYYY-MM-DD');
       var check = moment(datestart1, 'YYYY/MM/DD');
       var month = check.format('M');
       this.formattedMonth2 = moment(month, 'MM').format('MMMM');
       this.year  = check.format('YYYY');
      
       let argsw1 = { 
        developerId:  element.developerId,
        fromDate: datestart1,
        toDate: dateend1, 
      }
      this.resellerService.getTotalCount(argsw1).subscribe( async (data) =>{
        if(data.status==200){
        element['sentPreviousMonth1Count']=data.info.totalCount ?  data.info.totalCount  : 0;
       
        }
        });

        this.resellerService.getTotalReceivedCount(argsw1).subscribe(async (data) =>{
          if(data.status==200){
            element['receivePreviousMonth1Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
           
          }
          });


          var datestart2 = moment(this.todaysDate).subtract(2,'months').startOf('month').format('YYYY-MM-DD');
          var dateend2 = moment(this.todaysDate).subtract(2,'months').endOf('month').format('YYYY-MM-DD');
          var check2 = moment(datestart2, 'YYYY/MM/DD');
          var month2 = check2.format('M');
          this.year2  = check2.format('YYYY');
          this.formattedMonth3 = moment(month2, 'MM').format('MMMM');
          
          let argsw2 = { 
           developerId:  element.developerId,
           fromDate: datestart2,
           toDate: dateend2, 
         }
         this.resellerService.getTotalCount(argsw2).subscribe( async (data) =>{
           if(data.status==200){
           element['sentPreviousMonth2Count']=data.info.totalCount ?  data.info.totalCount  : 0;
          
           }
           });
   
           this.resellerService.getTotalReceivedCount(argsw2).subscribe(async (data) =>{
             if(data.status==200){
               element['receivePreviousMonth2Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
              
             }
             });
   

             var datestart3 = moment(this.todaysDate).subtract(3,'months').startOf('month').format('YYYY-MM-DD');
             var dateend3 = moment(this.todaysDate).subtract(3,'months').endOf('month').format('YYYY-MM-DD');
             var check3 = moment(datestart3, 'YYYY/MM/DD');
             var month3 = check3.format('M');
             this.formattedMonth4 = moment(month3, 'MM').format('MMMM');
             this.year3  = check3.format('YYYY');
            
             let argsw3 = { 
              developerId:  element.developerId,
              fromDate: datestart3,
              toDate: dateend3, 
            }
            this.resellerService.getTotalCount(argsw3).subscribe( async (data) =>{
              if(data.status==200){
              element['sentPreviousMonth3Count']=data.info.totalCount ?  data.info.totalCount  : 0;
             
              }
              });
      
              this.resellerService.getTotalReceivedCount(argsw3).subscribe(async (data) =>{
                if(data.status==200){
                  element['receivePreviousMonth3Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                 
                }
                });


                var datestart4 = moment(this.todaysDate).subtract(4,'months').startOf('month').format('YYYY-MM-DD');
                var dateend4 = moment(this.todaysDate).subtract(4,'months').endOf('month').format('YYYY-MM-DD');
                var check4 = moment(datestart4, 'YYYY/MM/DD');
                var month4 = check4.format('M');
                this.formattedMonth5 = moment(month4, 'MM').format('MMMM');
                this.year4  = check4.format('YYYY');
                
                let argsw4 = { 
                 developerId:  element.developerId,
                 fromDate: datestart4,
                 toDate: dateend4, 
               }
               this.resellerService.getTotalCount(argsw4).subscribe( async (data) =>{
                 if(data.status==200){
                 element['sentPreviousMonth4Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                
                 }
                 });
         
                 this.resellerService.getTotalReceivedCount(argsw4).subscribe(async (data) =>{
                   if(data.status==200){
                     element['receivePreviousMonth4Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                    
                   }
                   });



                   var datestart5 = moment(this.todaysDate).subtract(5,'months').startOf('month').format('YYYY-MM-DD');
                   var dateend5 = moment(this.todaysDate).subtract(5,'months').endOf('month').format('YYYY-MM-DD');
                   var check5 = moment(datestart5, 'YYYY/MM/DD');
                   var month5 = check5.format('M');
                   this.year5  = check5.format('YYYY');
                   this.formattedMonth6 = moment(month5, 'MM').format('MMMM');
                  
                   let argsw5 = { 
                    developerId:  element.developerId,
                    fromDate: datestart5,
                    toDate: dateend5, 
                  }
                  this.resellerService.getTotalCount(argsw5).subscribe( async (data) =>{
                    if(data.status==200){
                    element['sentPreviousMonth5Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                   
                    }
                    });
            
                    this.resellerService.getTotalReceivedCount(argsw5).subscribe(async (data) =>{
                      if(data.status==200){
                        element['receivePreviousMonth5Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                       
                      }
                      });


                      var datestart6 = moment(this.todaysDate).subtract(6,'months').startOf('month').format('YYYY-MM-DD');
                      var dateend6 = moment(this.todaysDate).subtract(6,'months').endOf('month').format('YYYY-MM-DD');
                      var check6 = moment(datestart6, 'YYYY/MM/DD');
                      var month6 = check6.format('M');
                      this.formattedMonth7 = moment(month6, 'MM').format('MMMM');
                      this.year6  = check6.format('YYYY');
                     
                      let argsw6 = { 
                       developerId:  element.developerId,
                       fromDate: datestart6,
                       toDate: dateend6, 
                     }
                     this.resellerService.getTotalCount(argsw6).subscribe( async (data) =>{
                       if(data.status==200){
                       element['sentPreviousMonth6Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                      
                       }
                       });
               
                       this.resellerService.getTotalReceivedCount(argsw6).subscribe(async (data) =>{
                         if(data.status==200){
                           element['receivePreviousMonth6Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                          
                         }
                         });
   
   
   
                         var datestart7 = moment(this.todaysDate).subtract(7,'months').startOf('month').format('YYYY-MM-DD');
                         var dateend7 = moment(this.todaysDate).subtract(7,'months').endOf('month').format('YYYY-MM-DD');
                         var check7 = moment(datestart7, 'YYYY/MM/DD');
                         var month7 = check7.format('M');
                         this.year7  = check7.format('YYYY');
                         this.formattedMonth8 = moment(month7, 'MM').format('MMMM');
                        
                         let argsw7 = { 
                          developerId:  element.developerId,
                          fromDate: datestart7,
                          toDate: dateend7, 
                        }
                        this.resellerService.getTotalCount(argsw7).subscribe( async (data) =>{
                          if(data.status==200){
                          element['sentPreviousMonth7Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                         
                          }
                          });
                  
                          this.resellerService.getTotalReceivedCount(argsw7).subscribe(async (data) =>{
                            if(data.status==200){
                              element['receivePreviousMonth7Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                             
                            }
                            });



                            var datestart8 = moment(this.todaysDate).subtract(8,'months').startOf('month').format('YYYY-MM-DD');
                            var dateend8 = moment(this.todaysDate).subtract(8,'months').endOf('month').format('YYYY-MM-DD');
                            var check8 = moment(datestart8, 'YYYY/MM/DD');
                            var month8 = check8.format('M');
                            this.year8  = check8.format('YYYY');
                            this.formattedMonth9 = moment(month8, 'MM').format('MMMM');
                            
                            let argsw8 = { 
                             developerId:  element.developerId,
                             fromDate: datestart8,
                             toDate: dateend8, 
                           }
                           this.resellerService.getTotalCount(argsw8).subscribe( async (data) =>{
                             if(data.status==200){
                             element['sentPreviousMonth8Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                            
                             }
                             });
                     
                             this.resellerService.getTotalReceivedCount(argsw8).subscribe(async (data) =>{
                               if(data.status==200){
                                 element['receivePreviousMonth8Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                                
                               }
                               });




                            var datestart9 = moment(this.todaysDate).subtract(9,'months').startOf('month').format('YYYY-MM-DD');
                            var dateend9 = moment(this.todaysDate).subtract(9,'months').endOf('month').format('YYYY-MM-DD');
                            var check9 = moment(datestart9, 'YYYY/MM/DD');
                            var month9 = check9.format('M');
                            this.year9  = check9.format('YYYY');
                            this.formattedMonth10 = moment(month9, 'MM').format('MMMM');
                          
                            let argsw9 = { 
                             developerId:  element.developerId,
                             fromDate: datestart9,
                             toDate: dateend9, 
                           }
                           this.resellerService.getTotalCount(argsw9).subscribe( async (data) =>{
                             if(data.status==200){
                             element['sentPreviousMonth9Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                            
                             }
                             });
                     
                             this.resellerService.getTotalReceivedCount(argsw9).subscribe(async (data) =>{
                               if(data.status==200){
                                 element['receivePreviousMonth9Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                                
                               }
                               });





                               var datestart10 = moment(this.todaysDate).subtract(10,'months').startOf('month').format('YYYY-MM-DD');
                               var dateend10 = moment(this.todaysDate).subtract(10,'months').endOf('month').format('YYYY-MM-DD');
                               var check10 = moment(datestart10, 'YYYY/MM/DD');
                               var month10 = check10.format('M');
                               this.year10  = check10.format('YYYY');
                               this.formattedMonth11 = moment(month10, 'MM').format('MMMM');
                               
                               let argsw10 = { 
                                developerId:  element.developerId,
                                fromDate: datestart10,
                                toDate: dateend10, 
                              }
                              this.resellerService.getTotalCount(argsw10).subscribe( async (data) =>{
                                if(data.status==200){
                                element['sentPreviousMonth10Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                               
                                }
                                });
                        
                                this.resellerService.getTotalReceivedCount(argsw10).subscribe(async (data) =>{
                                  if(data.status==200){
                                    element['receivePreviousMonth10Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                                   
                                  }
                                  });



                                  var datestart11 = moment(this.todaysDate).subtract(11,'months').startOf('month').format('YYYY-MM-DD');
                                  var dateend11 = moment(this.todaysDate).subtract(11,'months').endOf('month').format('YYYY-MM-DD');
                                  var check11 = moment(datestart11, 'YYYY/MM/DD');
                                  var month11 = check11.format('M');
                                  this.year11  = check11.format('YYYY');
                                  this.formattedMonth12 = moment(month11, 'MM').format('MMMM');
                                 
                                  let argsw11 = { 
                                   developerId:  element.developerId,
                                   fromDate: datestart11,
                                   toDate: dateend11, 
                                 }
                                 this.resellerService.getTotalCount(argsw11).subscribe( async (data) =>{
                                   if(data.status==200){
                                   element['sentPreviousMonth11Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                                  
                                   }
                                   });
                           
                                   this.resellerService.getTotalReceivedCount(argsw11).subscribe(async (data) =>{
                                     if(data.status==200){
                                       element['receivePreviousMonth11Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                                      
                                     }
                                     });

                                     

                                     var datestart12 = moment(this.todaysDate).subtract(12,'months').startOf('month').format('YYYY-MM-DD');
                                     var dateend12 = moment(this.todaysDate).subtract(12,'months').endOf('month').format('YYYY-MM-DD');
                                     var check12 = moment(datestart12, 'YYYY/MM/DD');
                                     var month12 = check12.format('M');
                                     this.year12  = check12.format('YYYY');
                                     this.formattedMonth13 = moment(month12, 'MM').format('MMMM');
                                    
                                     let argsw12 = { 
                                      developerId:  element.developerId,
                                      fromDate: datestart12,
                                      toDate: dateend12, 
                                    }
                                    this.resellerService.getTotalCount(argsw12).subscribe( async (data) =>{
                                      if(data.status==200){
                                      element['sentPreviousMonth12Count']=data.info.totalCount ?  data.info.totalCount  : 0;
                                     
                                      }
                                      });
                              
                                      this.resellerService.getTotalReceivedCount(argsw12).subscribe(async (data) =>{
                                        if(data.status==200){
                                          element['receivePreviousMonth12Count'] = data.info.totalCount ?  data.info.totalCount  : 0;
                                         
                                        }
                                        });
                                        this.arr =applicationList;
                                        this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 5, (this.page - 1) * 5 + 5));
                                        this.pageLoader=false;

      });
  
   }

   pageChanged2(page){
    this.page = page;
    this.sentCount(this.arr)
   this.dataSource = new MatTableDataSource(this.arr.slice((this.page - 1) * 5, (this.page - 1) * 5 + 5));
   
    }
}
